import { instanceEmployee } from '../../../../services/instances';

export const getHiringRanges = async (params: Record<string, any> = {}): Promise<any> => {
    const response = await instanceEmployee.get<any>('/hiring_range', { params });
    return response.data.data;
};

const createHiringRange = async (data: { employee_id: number; start_date: string; end_date: string }): Promise<any> => {
    const response = await instanceEmployee.post<any>('/hiring_range/create', data);
    return response.data;
};

const updateHiringRange = async (id: number, data: { hiring_range_id: number; employee_id: number; start_date: string; end_date: string }): Promise<any> => {
    const response = await instanceEmployee.patch<any>(`/hiring_range/${id}`, data);
    return response.data;
};

const deleteHiringRange = async (id: number): Promise<void> => {
    await instanceEmployee.delete<void>(`/hiring_range/${id}`);
};

export { createHiringRange, updateHiringRange, deleteHiringRange };
